module.exports = require("./chr-US.js");